import { renderToString } from 'react-dom/server'
import userCan from 'Shared/functions/userCan'

const columns = [
  {
    data: 'name',
    className: 'bold',
    width: '55%',
    render: function (data, type, row, meta) {
      if (row['delegated_to_user'] === true || row['delegated_to_user'] === 'true') {
        return renderToString(<span>{data}</span>)
      }
      return renderToString(<a href={row['url']}>{data}</a>)
    },
  },
  {
    data: 'target_count',
    width: '25%',
    render: function (data, type, row, meta) {
      const count = Number(row['target_count']).toLocaleString()
      return `<span>${count}</span>`
    }
  },
  { data: 'created_at', width: '20%'}
]

const headers = [
  'Name',
  'Number of people',
  'Created'
]

let filters = []

if (userCan('manage_users')) {
  filters.push({ name: 'Created by', kind: 'async', entity: 'user' })
}

const permissions = window.ENV.CURRENT_USER_PERMISSIONS || []
if (permissions.includes('manage_client_admin') || permissions.includes('manage_admin')) {
  const organisationKinds = window.ENV.ORGANISATION_KINDS.map(kind => ({
    label: kind.label,
    value: kind.external_type
  }))

  filters.push(
    { name: 'Organisation', kind: 'async', entity: 'organisation' }
  )

  if (organisationKinds.length > 1) {
    filters.push({
      name: 'Organisation type',
      kind: 'radio-async',
      entity: 'external_type',
      options: organisationKinds
    })
  }
}

const defaultFilters = [
  { name: "Organisation", label: window.ENV.ORGANISATION_NAME, value: window.ENV.ORGANISATION_ID }
]

const sorters = [
  { column: 2, label: 'Created', order: 'desc' },
  { column: 0, label: 'Alphabetically (A-Z)', order: 'asc' },
  { column: 0, label: 'Alphabetically (Z-A)', order: 'desc' }
]

const order = [[ 2, "desc" ]]

export { columns, headers, filters, defaultFilters, sorters, order }
